// extracted by mini-css-extract-plugin
module.exports = {"card":"Service_card__1v145","card-title":"Service_card-title__1WlCH","card-description":"Service_card-description__2q4yg","button":"Service_button__2nPOk"};